<template>
  <div class="page-home">
    <div class="g-wrap news-wrap">
      <div class="news">
        <column-header2 :data="newsColumn"></column-header2>
        <div class="column-wrap">
          <ic-slide-news :data="slideNews"></ic-slide-news>
          <ic-news :data="topNews"></ic-news>
        </div>
      </div>
      <div class="industry">
        <column-header2 :data="industryColumn"></column-header2>
        <div class="column-wrap">
          <ic-news :data="industryNews" type="calendar"></ic-news>
        </div>
      </div>
    </div>
    <div class="preach-wrap">
      <div class="g-wrap">
        <column-header2 :data="preachColumn"></column-header2>
        <div class="column-wrap">
          <preach-card
            v-for="item in preachList"
            :data="item"
            :key="item.id"
          ></preach-card>
        </div>
      </div>
    </div>
    <div class="g-wrap job-wrap">
      <column-header2 :data="jobColumn"></column-header2>
      <div class="column-wrap">
        <job-card
          v-for="item in jobList"
          :data="item"
          :key="item.id"
        ></job-card>
      </div>
    </div>
  </div>
</template>

<script>
import JobCard from "./JobCard";
import PreachCard from "./PreachCard";
import ColumnHeader from "_c/ColumnHeader2";
import SlideNews from "_c/SlideNews";
import News from "_c/News";
import { getData } from "api/app";
import { mapState } from "vuex";

export default {
  name: "panel-hiring",
  data() {
    return {
      newsColumn: {
        name: "企业招工信息",
        link: this.$subsitePrefix + "/ah/column/recruit/list"
      },
      industryColumn: {
        name: "企业招聘会",
        link: this.$subsitePrefix + "/ah/column/meeting/list"
      },
      jobColumn: {
        name: "招聘岗位",
        link: this.$subsitePrefix + "/ah/column/job/list"
      },
      preachColumn: {
        name: "线上宣讲会",
        link: this.$subsitePrefix + "/ah/preach/list"
      },
      slideNews: [],
      topNews: [],
      industryNews: [],
      jobList: [],
      preachList: []
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  components: {
    [JobCard.name]: JobCard,
    [ColumnHeader.name]: ColumnHeader,
    [SlideNews.name]: SlideNews,
    [News.name]: News,
    [PreachCard.name]: PreachCard
  },
  methods: {
    loadSlideNews() {
      let params = [
        {
          Key: "College",
          Value: this.collegeData.college.Id,
          CompareType: "EqualTo"
        },
        {
          Key: "Illustration",
          Value: "",
          CompareType: "NotEqualTo"
        }
      ];
      console.log(this.collegeData);
      getData({
        name: "RecruitNews",
        top: 5,
        params: params
      }).then(res => {
        //企业招工信息图片
        const arr = [];

        res.forEach(item => {
          arr.push({
            ...item,
            link:
              this.$subsitePrefix +
              `/ah/column/recruit/detail/RecruitNews?id=${item.Id}`
          });
        });
        this.slideNews = arr || [];
      });
    },
    loadTopNews() {
      let params = [
        {
          Key: "College",
          Value: this.collegeData.college.Id,
          CompareType: "EqualTo"
        }
      ];
      getData({ name: "RecruitNews", top: 4, params: params }).then(res => {
        //企业招工信息列表
        const arr = [];
        res.forEach(item => {
          arr.push({
            ...item,
            link:
              this.$subsitePrefix +
              `/ah/column/recruit/detail/RecruitNews?id=${item.Id}`
          });
        });
        this.topNews = arr || [];
      });
    },
    loadIndustryNews() {
      getData({ name: "SpecialJobFair", top: 4 }).then(res => {
        //企业招聘会
        const arr = [];
        res.forEach(item => {
          arr.push({
            Headline: item.Name,
            Summary: item.Organizer,
            IssueTime: item.CreatedTime,
            Id: item.Id,
            name: "SpecialJobFair",
            link:
              this.$subsitePrefix +
              `/ah/column/meeting/detail/SpecialJobFair?id=${item.Id}`
          });
        });
        this.industryNews = arr || [];
        console.log("企业招聘会", this.industryNews);
      });
    },
    loadData() {
      this.loadSlideNews();
      this.loadTopNews();
      this.loadIndustryNews();
      let params = [
        {
          Key: "College",
          Value: this.collegeData.college.Id,
          CompareType: "EqualTo"
        }
      ];
      //todo
      var enterpriseIds = [];
      this.collegeData.listEnterprise.forEach(e => {
        enterpriseIds.push(e.Id);
      });
      var recruitJobQueryParam = {
        name: "RecruitJob",
        top: 4,
        params: [
          {
            Key: "Enterprise",
            Value: enterpriseIds.join(","),
            CompareType: "In"
          }
        ]
      };
      getData(recruitJobQueryParam).then(res1 => {
        //招聘岗位
        const arr = [];
        var ids = [];
        res1.forEach(e => {
          ids.push(e.JobId);
        });
        if (ids.length > 0) {
          var jobQueryParam = {
            name: "Job",
            params: [
              {
                Key: "Id",
                Value: ids.join(","),
                CompareType: "In"
              }
            ]
          };
          getData(jobQueryParam).then(res2 => {
            res1.forEach(item => {
              arr.push({
                PostName: item.JobName,
                Salary: res2.find(o => o.Id == item.JobId).Salary,
                Enterprise: item.Enterprise,
                IssueTime: item.CreatedTime,
                HiringCount: item.RecruitCount,
                Id: item.Id
              });
              this.jobList = arr || [];
            });
          });
        } else {
          this.jobList = [];
        }
      });
      getData({ name: "Preach", top: 3, params: params }).then(res => {
        //线上宣讲会
        const arr = [];
        res.forEach(item => {
          arr.push({
            id: item.Id,
            pic: item.Picture,
            name: item.Headline,
            view: item.ViewCount ?? 0,
            time: item.StartTime,
            link: item.LiveUrl
          });
        });
        this.preachList = arr || [];
      });
    },
    init() {
      this.id = this.$route.query.id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.column-wrap {
  display: flex;
}
.news-wrap {
  display: flex;
  @include clearfix();
  padding-bottom: 40px;
  .news {
    margin-right: 24px;
  }
  .comp-slide-news {
    width: 376px;
    margin-right: 24px;
    height: 266px;
  }
  .comp-news {
    width: 376px;
    height: 266px;
  }
  .industry {
    width: 376px;
  }
}
.job-wrap {
  padding: 40px 0;
  .column-wrap {
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
.preach-wrap {
  background-color: #f6f6f9;
  padding-bottom: 16px;
}
</style>
